import { Component } from 'react';
import { css } from '@emotion/react';

import Header from '../atoms/Header';
import Caption from '../atoms/Caption';
import BodyText from '../atoms/BodyText';
import Title from '../atoms/Title';

import * as InternalPropTypes from '../../../constants/internal-types';
import * as Breakpoints from '../../../constants/breakpoints';
import {
  HeroTypeEnum,
  TypeHeroTypes,
  TypeSEOWeightTypes,
} from '../../../constants/cms-constants';
import TitleTypes from '../../../constants/title-types';
import SEOWeights from '../../../constants/cms/control-options/seo-weights';
import { getSEOWeight } from '../../../utils/SEOWeight';

const styles = css({
  '& .caption': {
    opacity: '0.5',
    position: 'relative',
    [Breakpoints.Mobile.mq]: {
      marginBottom: '20px',
    },
    [Breakpoints.Tablet.mq]: {
      marginBottom: '18px',
    },
    [Breakpoints.DesktopUp.mq]: {
      marginBottom: '18px',
    },
  },
  '& .header-text': {
    [Breakpoints.Mobile.mq]: {
      marginBottom: '18px',
    },
    [Breakpoints.TabletUp.mq]: {
      marginBottom: '24px',
    },
  },
  '& .body-text': {
    [Breakpoints.Mobile.mq]: {
      marginBottom: '48px',
    },
  },
  '& .title': {
    [Breakpoints.TabletUp.mq]: {
      marginBottom: '16px',
    },
  },
  '& .absolute-text': {
    [Breakpoints.TabletUp.mq]: {
      bottom: '0',
    },
  },
});

const enum HeroTextTypeEnum {
  ARTICLE = 'article-hero',
  PAGE = 'page-hero',
  DEFAULT = 'default',
  SIGNUP = 'signup-hero',
  SIGNUP_EVENT = 'signup-hero-event',
}

type HeroTextProps = {
  header?: InternalPropTypes.RichText;
  lightHeader?: InternalPropTypes.RichText;
  text?: InternalPropTypes.RichText;
  type?: TypeHeroTypes;
  seoWeight?: TypeSEOWeightTypes;
};

class HeroText extends Component<HeroTextProps> {
  static ARTICLE = HeroTypeEnum.ARTICLE;

  static PAGE = HeroTypeEnum.PAGE;

  static SIGNUP = HeroTextTypeEnum.SIGNUP;

  static DEFAULT = HeroTextTypeEnum.DEFAULT;

  static defaultProps = {
    header: null,
    lightHeader: null,
    text: null,
    type: null,
    seoWeight: SEOWeights.H1,
  };

  render() {
    const { header, lightHeader, text, type, seoWeight } = this.props;
    const addSEOWeight = getSEOWeight(seoWeight, seoWeight);
    return (
      <div css={styles} className="hero-text">
        <Caption
          type={
            type === HeroText.ARTICLE || type === HeroText.PAGE
              ? Caption.types.HERO
              : Caption.types.SECTION
          }
        >
          {lightHeader}
        </Caption>

        {type === HeroText.PAGE && (
          <Header
            type={
              type === HeroText.PAGE ? Header.types.PAGE : Header.types.ARTICLE
            }
            seoWeight={addSEOWeight}
          >
            {header}
          </Header>
        )}

        <div
          className={`text-container ${
            type === HeroText.ARTICLE ? 'absolute-text' : ''
          }`}
        >
          {type === HeroText.ARTICLE && (
            <Header type={Header.types.ARTICLE}>{header}</Header>
          )}

          {type !== HeroText.ARTICLE && type !== HeroText.PAGE && (
            <Title
              seoWeight={addSEOWeight}
              className="title"
              type={TitleTypes.SECTION}
            >
              {header}
            </Title>
          )}

          {text !== null && (
            <BodyText
              type={
                type === HeroText.ARTICLE
                  ? BodyText.types.ARTICLE
                  : BodyText.types.STATIC16
              }
            >
              {text}
            </BodyText>
          )}
        </div>
      </div>
    );
  }
}

export default HeroText;
